module.exports = __webpack_public_path__ + "img/vsc-64x64.6c6ab448.png";